import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { VisAuthService } from '@vis-auth/react';
import { I18nextProvider } from 'react-i18next';
import i18n from './localization/i18n';
import Footer from './components/footer.component';

export default function Root({ authService }: { authService?: VisAuthService }) {
  return (
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <Footer authService={authService} />
      </I18nextProvider>
    </BrowserRouter>
  );
}
